<div class="marketplace_section" id="nft">
  <div class="container">
    <div class="row">            
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="common_home_section opeansea_card "> 
          <div>               
            <img src="/img/images/OpeanSea.svg" alt="OpeanSea"/>
            <h2>OpenSea</h2>
            <p>The Dogs of Elon collection of 10,000 NFTs is available on the world's largest NFT Marketplace.<br/><br/>
              Browse, favorite and place your bids for your favorite DOE Doge!
            </p>
          </div>
          <div class="btn_group">                   
            <a href="https://opensea.io/collection/dogs-of-elon" target="_blank" rel="noreferrer" class="fill_btn">View Collection</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="common_home_section opeansea_card"> 
          <div>               
            <img src=/img/images/LooksRare.svg alt="LooksRare"/>
            <h2>LooksRare</h2>
            <p>A Marketplace where you can browse and buy Dogs of Elon NFTs for a slightly lower fee.
            </p>
          </div>
          <div class="btn_group">                   
            <a href="https://looksrare.org/collections/0xD8CDB4b17a741DC7c6A57A650974CD2Eba544Ff7" target="_blank" rel="noreferrer" class="fill_btn">View Collection</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="common_home_section opeansea_card">
          <div>                
            <img src=/img/images/DOEsplorer.svg alt="DOEsplorer"/>
            <h2>NFT Explorer</h2>
            <p>Browse and Compare the Dogs of Elon Collection in our Custom Database with the Official Rarity Rankings.
            </p>
          </div>
          <div class="btn_group">                   
            <a href="http://explorer.dogsofelon.io/" target="_blank" rel="noreferrer" class="fill_btn">View Collection</a>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>